import React, { Component } from 'react'
import classnames from 'classnames';
import '../../assets/styles/components/dropdown.scss';
import { connect } from 'react-redux';
import { KEY_CODE } from "@/constants/keys.code";

class DropdownOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenIndex: 0,
      positionTop: props.position.top + props.position.height + 5,
      searchResult:props.options,
      currentName:''
    }
    this.optionsRef = React.createRef();
  }

  render() {
    const { language, options, position, textCenter, defaultTheme, theme,DropdownStyle,isMobile } = this.props;
    const { chosenIndex, positionTop , searchResult, currentName} = this.state;
    return (
      
      <div className={'theme-' + (defaultTheme || theme)}>
        <div className='dropdown-options-container' onClick={this.handleClose}  >
          <div className={classnames('dropdown-container')}>
            <div className={classnames('dropdown-content', 'dropdown-content-open')} style={{ top: positionTop, left: position.left, width: position.width,backgroundColor:DropdownStyle?.backgroundColor}} onClick={this.handleNotClose}>
                <div className='dropdown-search-box'>
                  <input placeholder={language.common_search} className='dropdown-search-input' onChange={e=> this.dropdownSearch(e)}></input>
                </div>
            </div>
            
            <div
              ref={this.optionsRef}
              className={classnames('dropdown-content', 'dropdown-content-open')}
              style={{ top: positionTop + 27, left: position.left, width: position.width,backgroundColor:DropdownStyle?.backgroundColor}}>
              {searchResult.map((o, index) => {
                const label = language[o.label] || o.label
                const currentSelect =  language[currentName] || currentName
                return (
                  <div className={classnames('dropdown-option', label === currentSelect ?
                  DropdownStyle?.active ? 'virtual-trading-color' : 'dropdown-option-chosen' : undefined)}
                    style={{
                      display: o.isVisible || searchResult.length === 1 ? 'block' : 'none',
                      textAlign: textCenter ? 'center' : 'left',
                      color:DropdownStyle?.color,
                      borderBottom:DropdownStyle?.borderBottom
                    }}
                    key={o.value}
                    onMouseEnter={() => this.handleMouseEnter(index)}
                    onClick={(e) => this.handleChooseOption(e, index)}>
                    <p title={label} style={{fontSize:isMobile?'14px' : ''}}>{label}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // componentDidUpdate(preProps){
  //   const { searchResult } = this.state
  //   const { options } = this.props
  //   if(searchResult.length === 0 && searchResult !== preProps){
  //     this.setState({searchResult:options})
  //   }
  // }

  dropdownSearch = (e) =>{
    const { options , language} = this.props
    if(!e.target.value){
      this.setState({searchResult:options})
      return
    }
      let searchResult = options.reduce((t,v) => ((language[v.label] ||v.label ).toUpperCase().includes(e.target.value.toUpperCase()) && t.push(v),t),[] );
      this.setState({searchResult})


  }

  handleNotClose=(event) => {
    event.stopPropagation();
  }

  handleClose = (event) => {
    event.stopPropagation();
    this.props.onClose();
  }

  handleChooseOption = (event) => {
    const { options } = this.props
    const { currentName } = this.state
    event.stopPropagation();
    let num = options.findIndex((value,index) => {
      return value.label == currentName
    })
    this.props.onClose(num)
  }

  handleMouseEnter(index) {
    this.setState({currentName:this.state.searchResult[index].label})
  }

  onKeyDown = e => {
    if (this.optionsRef.current) {
      const { options , searchResult} = this.props;
      const { chosenIndex } = this.state;
      switch (e.keyCode) {
        case KEY_CODE.TAB_KEY: {
          this.handleClose(e);
          return;
        }
        case KEY_CODE.ENTER_KEY: {
          this.handleChooseOption(e, chosenIndex)
          return;
        }
        case KEY_CODE.ESC_KEY: {
          this.handleClose(e);
          return;
        }
        case KEY_CODE.UP_ARROW_KEY: {
          for (let i = 1; i < searchResult.length; i++) {
            let tmpIndex = (chosenIndex - i) % searchResult.length;
            if (tmpIndex < 0) {
              tmpIndex += searchResult.length
            }
            if (searchResult[tmpIndex].isVisible) {
              this.setState({ chosenIndex: tmpIndex });
              break;
            }
          }
          return;
        }
        case KEY_CODE.DOWN_ARROW_KEY: {
          for (let i = 1; i < searchResult.length; i++) {
            let tmpIndex = (chosenIndex + i) % searchResult.length;
            if (searchResult[tmpIndex].isVisible) {
              this.setState({ chosenIndex: tmpIndex });
              break;
            }
          }
          return;
        }
        default:
          return;
      }
    }
  }

  componentDidMount() {
    const { position, options ,} = this.props;
    const { chosenIndex,searchResult } = this.state;
    // Determine render position
    const el = this.optionsRef.current.getBoundingClientRect();
    const elHeight = el.height;
    const isOpenAbove = elHeight + position.top + position.height + 5 > window.innerHeight;
    let newTop = position.top + position.height + 5;
    if (isOpenAbove) {
      newTop = position.top - 5 - elHeight;
    }
    this.setState({ positionTop: newTop })
    // Hover first available option
    for (let i = 1; i < searchResult.length; i++) {
      let tmpIndex = (chosenIndex + i) % searchResult.length;
      if (searchResult[tmpIndex].isVisible) {
        this.setState({ chosenIndex: tmpIndex });
        break;
      }
    }
    setTimeout(() => document.addEventListener('keydown', this.onKeyDown.bind(this)), 0)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown.bind(this))
  }
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme,
    isMobile: state.app.isMobile
  })
)(DropdownOptions)
